import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    redirectUrl: String,
    interval: { type: Number, default: 1000 }
  }

  connect() {
    this.timer = setInterval(() => {
      if (this.redirectUrlValue) {
        window.location.href = this.redirectUrlValue
      }
    }, this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }
}
